import * as React from "react";
import { ReactNode } from "react";
import { ActionIcon, Anchor, Container, createStyles, Menu, Text } from "@mantine/core";
import { ChevronDown } from "tabler-icons-react";

import { _NavItem } from "./_GlobalNav";

const useStyles = createStyles(
	(
		_theme,
		{
			color,
			hoverColor,
			mobile,
		}: { color: string; hoverColor: string; mobile: boolean }
	) => ({
		navItem: {
			paddingLeft: mobile ? "0rem": "1.25rem",
			paddingRight: mobile ?"0rem": "1.25rem",
			textAlign: "right",
			cursor: "pointer",
			color,
			"&:hover": {
				color: hoverColor,
			},
			fontSize: "1.125rem",
			lineHeight: "1.75rem",
			textTransform: "uppercase",
			fontWeight: 500,
		},
		childItem: {
			color: "rgba(51,51,51) !important",
			"&:hover": {
				color: "rgba(51,51,51)",
			},
			fontSize: "1rem",
			lineHeight: "1.5rem",
			cursor: "pointer",
			fill: "rgba(51, 51, 51, 0.5)",
		},
		link: {
			textDecoration: "none !important",
			color,
			"&:hover": {
				color: hoverColor,
			},
			width: "100%",
		},
	})
);

interface Props {
	item: _NavItem;
	lightBg: boolean;
	mobile: boolean;
	makeWrapper?: (url: string | undefined, child: ReactNode) => ReactNode;
	activeHref?: string;
}
const _ExternalNavElement: React.FC<Props> = ({
	item,
	lightBg,
	mobile,
	makeWrapper,
	activeHref,
}) => {
	const active = typeof activeHref !== "undefined" && activeHref === item.href;
	let color = lightBg ? "rgba(51,51,51)" : "rgba(255,255,255,0.8)";
	let hoverColor = lightBg ? "rgba(51,51,51)" : "rgba(255,255,255,1)";
	color = active || mobile ? hoverColor : color;
	hoverColor = !mobile ? hoverColor : color;

	const { classes } = useStyles({ color, hoverColor, mobile });

	return item.childItems ? (
		<Menu position="bottom-end" closeOnItemClick={true} width={200}>
			<Menu.Target>
				<Container
					style={{ display: "flex" }}
					className={classes.navItem}
					fluid={true}
				>
					<div style={{ lineHeight: "1.75rem" }}>{item.title as ReactNode}</div>
					<ActionIcon variant="transparent">
						<ChevronDown color={color} strokeWidth={1} size={24} />
					</ActionIcon>
				</Container>
			</Menu.Target>
			<Menu.Dropdown>
				{item.childItems.map((childItem, i) => (
					<Menu.Item
						onClick={childItem.onClick ? childItem.onClick : undefined}
						key={i}
						pl="xs"
						py="xs"
					>
						{makeWrapper ? (
							<div className={classes.link + " " + classes.childItem} key={i}>
								{makeWrapper(childItem.href, <Text>{childItem.title as ReactNode}</Text>)}
							</div>
						) : (
							<Anchor
								target="_blank"
								display={"block"}
								href={childItem.href}
								className={classes.link + " " + classes.childItem}
							>
								{childItem.title as ReactNode}
							</Anchor>
						)}
					</Menu.Item>
				))}
			</Menu.Dropdown>
		</Menu>
	) : (
		<Container className={classes.navItem} fluid={true}>
			{makeWrapper ? (
				<div className={classes.link}>
					{makeWrapper(item.href, item.title as string)}
				</div>
			) : (
				<a href={item.href} className={classes.link}>
					{item.title as ReactNode}
				</a>
			)}
		</Container>
	);
};

export default _ExternalNavElement;
